const actions = {
    // CREATE USER
    CREATE_USER: "CREATE_USER",
    CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
    CREATE_USER_FAILED: "CREATE_USER_FAILED",
    // GET ASSIGNABLE ROLES
    GET_ASSIGNABLE_ROLES: "GET_ASSIGNABLE_ROLES",
    GET_ASSIGNABLE_ROLES_SUCCESS: "GET_ASSIGNABLE_ROLES_SUCCESS",
    GET_ASSIGNABLE_ROLES_FAILED: "GET_ASSIGNABLE_ROLES_FAILED",
    // GET USER LIST
    GET_USER_LIST: "GET_USER_LIST",
    GET_USER_LIST_SUCCESS: "GET_USER_LIST_SUCCESS",
    GET_USER_LIST_FAILED: "GET_USER_LIST_FAILED",
    // MODIFY USER
    MODIFY_USER: "MODIFY_USER",
    MODIFY_USER_SUCCESS: "MODIFY_USER_SUCCESS",
    MODIFY_USER_FAILED: "MODIFY_USER_FAILED",
    RESET_MESSAGE: "RESET_MESSAGE",

    // CREATE USER
    createUser: (data) => ({
        type: actions.CREATE_USER,
        payload: { data },
    }),

    createUserSuccess: (message) => ({
        type: actions.CREATE_USER_SUCCESS,
        message,
    }),

    createUserError: (error) => ({
        type: actions.CREATE_USER_FAILED,
        error,
    }),
    // GET ASSIGNABLE ROLES
    getAssignableRoles: () => ({
        type: actions.GET_ASSIGNABLE_ROLES,
    }),

    getAssignableRolesSuccess: (data) => ({
        type: actions.GET_ASSIGNABLE_ROLES_SUCCESS,
        payload: { data },
    }),

    getAssignableRolesError: (error) => ({
        type: actions.GET_ASSIGNABLE_ROLES_FAILED,
        error,
    }),
    // GET USER LIST
    getUserList: (data) => ({
        type: actions.GET_USER_LIST,
        payload: { data },
    }),

    getUserListSuccess: (data) => ({
        type: actions.GET_USER_LIST_SUCCESS,
        payload: { data },
    }),

    getUserListError: (error) => ({
        type: actions.GET_USER_LIST_FAILED,
        error,
    }),

    // MODIFY USER
    modifyUser: (data) => ({
        type: actions.MODIFY_USER,
        payload: { data },
    }),

    modifyUserSuccess: (message) => ({
        type: actions.MODIFY_USER_SUCCESS,
        message,
    }),

    modifyUserError: (error) => ({
        type: actions.MODIFY_USER_FAILED,
        error,
    }),
    // RESET
    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),
};

export default actions;